<template>
  <div id="home">
    <img 
      src="../assets/imgs/a.svg" 
      alt="sm-logo"
    >
    <div class="container">
      <h1>ChenHsuanAn, <br>Graphic Designer from Taiwan. <br>Born in Tainan in 1990 and graduated from Da-Yeh University with a BA Degree in Visual Communication Design (in 2014).<br>
        I have been a freelance designer since 2016 and have over 5 years of experience in book design, typography, type design, music album design, brand identity planning, and graphic design for art performances and exhibitions.</h1>
      <div class="btns">
        <a 
          href="https://www.facebook.com/ChenHsuanAn" 
          target="_blank"
        >Facebook</a>
        <a 
          href="https://www.instagram.com/chenhsuanan.design" 
          target="_blank"
        >Instagram</a>
        <a href="mailto:anchen.design@gmail.com">E-mail</a>
      </div>
      <h6>Copyright© ChenHsuanAn.com</h6>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#home {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 66px;
  flex-direction: column;
  position: relative;
}

img {
  position: absolute;
  width: 24px;
  right: 20px;
  top: 20px;
}

.container {
  max-width: 600px;
}

h1 {
  font-size: 19px;
  letter-spacing: 0.3px;
  line-height: 132%;
  font-weight: normal;
}

.btns {
  margin-top: 50px;
}

a {
  margin-right: 20px;
  font-size: 19px;
  color: black;
  &:hover {
    color: #bfbfbf;
  }
  @media only screen and (max-width: 416px) {
    display: block;
    margin-bottom: 12px;
  }
}

h6 {
  font-weight: normal;
  font-size: 14px;
}
</style>
